export { TitleController };
window.TitleController = TitleController;
function TitleController(stepController) {
   if (App.hideControls) {
      // Start on the intro page when controls are hidden.
      // If controls are hidden, then we're in operator view.
      startGuide();
      return;
   }

   var stepIndicator = window.location.hash.match(/^#s(\d+)$/);
   if (stepIndicator) {
      // Start on the step number the user has requested via the anchor if it
      // is in range. If the step number is too large, do nothing.
      var stepNumber = parseInt(stepIndicator[1], 10);
      stepController.maxStepNumber().then(function(maxStepNumber) {
         if (stepNumber <= maxStepNumber) {
            startGuideOnStep(stepNumber);
         }
      });
   }

   $('.js-start').click(startGuide);

   function startGuide() {
      stepController.showNext();
      $('.js-title-page').hide();
   }

   function startGuideOnStep(stepNumber) {
      stepController.showStep(stepNumber);
      $('.js-title-page').hide();
   }
}
